import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

import AdminNavbar from "../AdminNavbar";
import Footer from "../../components/common/Footer";

import "../../assets/css/home.css";

function AdminHome() {

    const [heroImage, setHeroImage] = useState("");

    const [heroVideo, setHeroVideo] = useState("");

   

    useEffect(() => {

    const loadHeroMedia = async () => {

        try {

            const docRef = doc(db, "website_settings", "home");

            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {

                const data = docSnap.data();

                setHeroImage(data.heroImage || "");

                setHeroVideo(data.heroVideo || "");

            }

        } catch (error) {

            console.log("Error loading home media:", error);

        }

    };

    loadHeroMedia();

}, []);

    return (

        <>
              
            <AdminNavbar />

            <section className="hero">

                {/* ===========================
                        Background Video
                =========================== */}

                {
                    heroVideo ? (

                        <video
                            className="hero-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                        >

                            <source
                                src={heroVideo}
                                type="video/mp4"
                            />

                            Your browser does not support video.

                        </video>

                    ) : (

                        <div

                            className="hero-image"

                            style={{

                                backgroundImage: heroImage

                                    ? `url(${heroImage})`

                                    : "none"

                            }}

                        />

                    )
                }

                {/* Dark Overlay */}

                <div className="hero-overlay"></div>

                {/* Hero Content */}

                <div className="hero-content">

                    <h4>
                        WELCOME TO
                    </h4>

                    <h1>

                        StoryLine <br />

                        Studios

                    </h1>

                    <p>

                        Capturing timeless love stories with
                        luxury photography and cinematic films
                        that preserve every emotion forever.

                    </p>

                    <div className="hero-buttons">

                        <Link
                            to="/gallery"
                            className="portfolio-btn"
                        >
                            View Portfolio
                        </Link>

                        <Link
                            to="/contact"
                            className="book-btn"
                        >
                            Book Now
                        </Link>

                        <a
                            href="https://wa.me/6302175770?text=Hello%20StoryLine%20Studios,%20I%20would%20like%20to%20book%20a%20photoshoot."
                            target="_blank"
                            rel="noreferrer"
                            className="whatsapp-btn"
                        >
                            WhatsApp
                        </a>

                    </div>
                                        {/*==========================================
                            Luxury Statistics
                    ==========================================*/}

                    <div className="hero-stats">

                        <div className="hero-stat-card">

                            <h2>500+</h2>

                            <span>Luxury Weddings</span>

                        </div>

                        <div className="hero-stat-card">

                            <h2>8+</h2>

                            <span>Years Experience</span>

                        </div>

                        <div className="hero-stat-card">

                            <h2>1000+</h2>

                            <span>Happy Clients</span>

                        </div>

                    </div>

                </div>

                {/*==========================================
                        Scroll Indicator
                ==========================================*/}

                <div className="scroll-indicator">

                    <span></span>

                    <p>Scroll</p>

                </div>

            </section>

            <Footer />

        </>

    );

}

export default AdminHome;